import React from 'react';
import PropTypes from 'prop-types';
InfoboxColumn.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.any,
    icon: PropTypes.string
};
export default function InfoboxColumn(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.value, value = _d === void 0 ? '' : _d, _e = _a.icon, icon = _e === void 0 ? '' : _e;
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "infoboxes-column__inner" },
            React.createElement("div", { className: "infobox__label" }, label),
            React.createElement("div", { className: "infobox__footer" },
                React.createElement("div", { className: "infobox__text" }, value),
                icon ? React.createElement("span", { className: 'icon icon--img icon--' + icon }) : null))));
}
